'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _baseUtils = require('../../utils/baseUtils');

var _versionManager = require('../versionManager.js');

var _versionManager2 = _interopRequireDefault(_versionManager);

var _proGalleryVersionManager = require('../proGalleryVersionManager');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenVersionManager = function () {
  function FullscreenVersionManager(proGallertVersionManager) {
    (0, _classCallCheck3.default)(this, FullscreenVersionManager);

    this.pgVersionManager = proGallertVersionManager || _proGalleryVersionManager.pgVersionManager;
  }

  (0, _createClass3.default)(FullscreenVersionManager, [{
    key: 'getVersionFullscreenVersion',
    value: function getVersionFullscreenVersion() {
      var version = this.pgVersionManager.getVersion('fullscreen');
      if (version === _versionManager2.default.Versions.min) {
        return _baseUtils.baseUtils.isDemoMode() || _baseUtils.baseUtils.isStoreGallery() ? 'V2' : version;
      }
      return version;
    }
  }, {
    key: 'useFullScreenWideSidebar',
    value: function useFullScreenWideSidebar() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullScreenMobilePadding',
    value: function useFullScreenMobilePadding() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullScreenMoreinfoButtonAlways',
    value: function useFullScreenMoreinfoButtonAlways() {
      return this.getVersionFullscreenVersion() === _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewDesktopNavbar',
    value: function useFullscreenNewDesktopNavbar() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewSidebar',
    value: function useFullscreenNewSidebar() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewSlider',
    value: function useFullscreenNewSlider() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewMobileLayout',
    value: function useFullscreenNewMobileLayout() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenSettingsNewVersion',
    value: function useFullscreenSettingsNewVersion() {
      return this.getVersionFullscreenVersion() !== _versionManager2.default.Versions.min;
    }
  }, {
    key: 'update',
    value: function update(dateCreated) {
      return this.pgVersionManager.update(dateCreated);
    }
  }]);
  return FullscreenVersionManager;
}();

var fullscreenVersionManager = new FullscreenVersionManager();

module.exports = { fullscreenVersionManager: fullscreenVersionManager, FullscreenVersionManager: FullscreenVersionManager };